import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Location, UpdateLocationDto } from 'types';

export const updateLocation = ({
  data,
  locationId,
}: {
  data: UpdateLocationDto;
  locationId: number;
}): Promise<Location> => {
  return axios.put(`/api/locations/${locationId}`, data);
};

type UseUpdateLocationOptions = {
  config?: MutationConfig<typeof updateLocation>;
};

export const useUpdateLocation = ({ config }: UseUpdateLocationOptions) => {
  return useMutation({
    onSuccess: () => {
      queryClient.refetchQueries(['locations']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: updateLocation,
  });
};
